import { Modal } from '@clientbase/clientbase-library'
import BodyModalNewChargeOrRecurrence, {
  ChargeBodyModalClientProps
} from 'templates/Customers/Modals/BodyModalNewChargeOrRecurrence/BodyModalNewChargeOrRecurrence'

type ModalNewChargeProps = {
  isOpenModalNewCharge: boolean
} & Omit<ChargeBodyModalClientProps, 'customers' | 'groups'>

const ModalNewCharge = ({
  isOpenModalNewCharge,
  handleCloseModal,
  handleOpenDetailChargeOrRecurrence,
  ...rest
}: ModalNewChargeProps) => {
  return (
    <Modal
      handleClose={handleCloseModal}
      open={isOpenModalNewCharge}
      width="100%"
      maxWidth="85vw"
      maxHeight="90vh"
      height="auto"
    >
      <BodyModalNewChargeOrRecurrence
        isCharge={true}
        handleCloseModal={handleCloseModal}
        handleOpenDetailChargeOrRecurrence={handleOpenDetailChargeOrRecurrence}
        {...rest}
      />
    </Modal>
  )
}

export default ModalNewCharge
